import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.page.html',
  styleUrls: ['./confirmation-modal.page.scss'],
})
export class ConfirmationModalPage implements OnInit {
  @Input() title = '';
  @Input() messages: string[] = [];
  @Input() cancelText = '';
  @Input() confirmText = '';
  @Input() type: 'destructive' | 'warning' | 'neutral' = 'neutral';
  @Input() alignText: 'left' | 'center' | 'right' = 'center';

  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {
  }

  onCancel() {
    this.modalController.dismiss({ confirm: false });
  }

  onConfirm() {
    this.modalController.dismiss({ confirm: true });
  }

}
